import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";
import { tratarMensagemDeErro } from "../helper/helper";

export const SolicitarFeriasService = {
  async postFerias(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      "ferias",
      postData,
    );
    if (response.error) {
      SnackBarModule(tratarMensagemDeErro(response.message), "error");
      return false;
    }

    const msg = await response.message;
    SnackBarModule(msg.sucesso, "success");
    return true;
  },

  async postFeriasPremio(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      "ferias/premio",
      postData,
    );
    if (response.error) {
      SnackBarModule(tratarMensagemDeErro(response.message), "error");
      return false;
    }

    SnackBarModule('Férias solicitadas com sucesso', "success");
    return true;
  },

  async postFeriasPremio30Anos(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      "ferias/premio/trinta-anos",
      postData,
    );
    if (response.error) {
      SnackBarModule(tratarMensagemDeErro(response.message), "error");
      return false;
    }

    SnackBarModule('Férias solicitadas com sucesso', "success");
    return true;
  },

  async postFeriasVantagem(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      "ferias/vantagem",
      postData,
    );
    if (response.error) {
      SnackBarModule(tratarMensagemDeErro(response.message), "error");
      return false;
    }

    SnackBarModule('Férias movidas para vantagem', "success");
    return true;
  },

  async pegarDiasRestantes(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      "ferias/diasRestantes",
      postData
    );
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }

    return await response.message;
  },

  async calcularDiasUteis(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      "calcula",
      postData,
    );
    return response.message;
  },
};